var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({cursor: _vm.selectedCursor}),attrs:{"id":"map"}},[_c('div',{staticClass:"mapStyle"})])}
var staticRenderFns = []

export { render, staticRenderFns }